var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ui-data-table',{attrs:{"p-headers":_vm.headers,"p-title":"Propagandas","p-read-link":"adverts.read.one","p-create-link":"adverts.create","p-name":"adverts"}})}
var staticRenderFns = []

export { render, staticRenderFns }